import React, { Component } from 'react'
import PropTypes from 'prop-types'
import configureAds from './configureAds'
import creatives from './creatives'
import styles from './styles'

class AdSlot extends Component {
  state = {
    creativeProps: null,
  }

  componentDidMount() {
    const {
      creative,
      path,
      programmeOrChannelGuid,
      adSlotProps,
    } = this.props

    const params = {
      divId: this.getDivId(),
      type: this.props.type,
      ...(creative && {
        onIframeLoad: [`init${creative}`, this.setCreativeProps],
      }),
      path,
      programmeOrChannelGuid,
      adSlotProps,
    }
    configureAds(params)
  }

  componentDidUpdate(prevProps) {
    // on client side navigation, make sure that
    // the targeting params change if the programme GUID does
    if (
      prevProps.programmeOrChannelGuid !== this.props.programmeOrChannelGuid
      && this.props.type === 'out-of-page'
    ) {
      // clear any existing wallpaper creatives
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ creativeProps: null }, () => {
        const slot = window?.dfpState?.adSlots['out-of-page']
        if (!slot) return
        slot.clearTargeting()
        slot.setTargeting('pr', this.props.programmeOrChannelGuid)
      })
    }
  }

  getDivId = () => this.props.divId || this.props.type

  setCreativeProps = creativeProps => this.setState({ creativeProps })

  render() {
    const { creativeProps } = this.state
    const AdCreative = creatives[this.props.creative]
    const shouldUseCreative = creativeProps && AdCreative

    if (shouldUseCreative) {
      return (
        <AdCreative {...creativeProps} id={this.getDivId()} />
      )
    }

    return (
      <div className={`dfp-ad ad ${this.props.type}`} id={this.getDivId()}>
        <style jsx>{styles}</style>
      </div>
    )
  }
}

AdSlot.propTypes = {
  type: PropTypes.string.isRequired,
  divId: PropTypes.string,
  creative: PropTypes.string,
  path: PropTypes.string,
  adSlotProps: PropTypes.object,
  programmeOrChannelGuid: PropTypes.string,
}

AdSlot.defaultProps = {
  divId: null,
  creative: null,
  path: null,
  programmeOrChannelGuid: null,
  adSlotProps: {},
}

export default AdSlot
